import { createContext, useContext, useEffect, useRef, useState, useCallback } from "react";
import { api } from "@/lib/api";

const Ctx = createContext(null);
const KEY = "lm_session";

export function SessionProvider({ children }) {
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);
  const idRef = useRef(null);

  useEffect(() => {
    const id = localStorage.getItem(KEY);
    if (!id) return setLoading(false);
    api.get(`/sessions/${id}`)
      .then(({ data }) => { idRef.current = data.id; setSession(data); })
      .catch(() => localStorage.removeItem(KEY))
      .finally(() => setLoading(false));
  }, []);

  const start = useCallback(async () => {
    const { data } = await api.post("/sessions");
    localStorage.setItem(KEY, data.id);
    idRef.current = data.id;
    setSession(data);
    return data;
  }, []);

  const update = useCallback(async (patch) => {
    setSession((s) => ({ ...s, ...patch }));
    const { data } = await api.patch(`/sessions/${idRef.current}`, patch);
    setSession(data);
    return data;
  }, []);

  const refresh = useCallback(async () => {
    const { data } = await api.get(`/sessions/${idRef.current}`);
    setSession(data);
    return data;
  }, []);

  const reset = useCallback(() => {
    localStorage.removeItem(KEY);
    idRef.current = null;
    setSession(null);
  }, []);

  return <Ctx.Provider value={{ session, loading, start, update, refresh, reset }}>{children}</Ctx.Provider>;
}

export const useSession = () => useContext(Ctx);
